import React from 'react';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {ItemCell, ItemContainer } from '../../components/modules/grids/Item';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import imgsv from '../../components/images/choosewines/intestato/BuonaSceltaVini.png';
import './sceglierevini.scss';
import '../../css/fonts/fonts.scss';

function ScegliereVini() {
    const {themes} = useThemes();
    // Componente 1 - Carica articles di choosewines
    const { articles: articles_UP } = useArticles('choosewines');
    const articles_Scelta = articles_UP || [];
    // Componente 2 - Carica articles di tipologia
    const { articles: articles_Down } = useArticles('tipologia');
    const articles_Tipologia = articles_Down || [];
    // Componente 3 e 4 - Carica Themes di choosewines e tipologia
    const choosewines_Theme = themes[1];
    const tipologia_Theme = themes[8]; 

    const links_Scelta = articles_Scelta.map(article => ({
        id: article._id,
        titolo: article.articolo_titolo,
        collegamento: article.collegamento
    }));

    const links_Tipologia = articles_Tipologia.map(article => ({
        id: article._id,
        titolo: article.articolo_titolo,
        collegamento: article.collegamento
    })); 

    return (
        <section className='grid-tema'>
            <div className="tema__photo"
                    style={{
                        backgroundImage: `linear-gradient( to right bottom, rgba(39, 38, 38, 0.2), rgba(29, 26, 26, 0.5)),
                        url(${imgsv})`, 
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center top',
                        filter: 'brightness(90%)'
                    }} >
            <ItemContainer tema={choosewines_Theme} exTema={tipologia_Theme} links_Up={links_Scelta} links_Down={links_Tipologia} /> 
            </div>
            <MenuMobile temi={themes}/>
            <div className="layout__grids">
                <ItemCell item={articles_Scelta} />
            </div>
            {tipologia_Theme && <div className="tema__title"><h1 className="title__top">{tipologia_Theme.name}</h1></div> }
            <div className="layout__grids">
                <ItemCell item={articles_Tipologia} />
            </div> 
        </section>
    )
}
export default ScegliereVini;
